import type { CSSProperties } from 'react';
import { scaleOf, shareOnScale } from '../ColumnChart/chart-scale.ts';
import { positionOf } from '../Chart/BucketLabels.tsx';
import styles from './Sparkline.module.css';

const VIEW_WIDTH = 100;

const VIEW_HEIGHT = 32;

export const sparklinePointsOf = (values: readonly number[]): string => {
  const scale = scaleOf(values);
  return values
    .map((value, index) => {
      const x = positionOf(index, values.length) * VIEW_WIDTH;
      const y = (1 - shareOnScale(scale, value)) * VIEW_HEIGHT;
      return `${String(x)},${String(y)}`;
    })
    .join(' ');
};

export const Sparkline = ({ values }: { values: readonly number[] }) => {
  if (values.length < 2) return null;
  const scale = scaleOf(values);
  const last = values.at(-1) ?? 0;
  return (
    <span className={styles['sparkline']} aria-hidden="true">
      <svg viewBox={`0 0 ${String(VIEW_WIDTH)} ${String(VIEW_HEIGHT)}`} preserveAspectRatio="none">
        <polyline className={styles['line']} points={sparklinePointsOf(values)} />
      </svg>
      <span
        className={styles['end']}
        style={{ '--spark-at': String(shareOnScale(scale, last)) } as CSSProperties}
      />
    </span>
  );
};
